import React, { useState } from "react";
import "./EmploymentVerification.css";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import InputField from "../InputField";
import { FileUploader } from "react-drag-drop-files";
import Bin from "../../assets/img/delete_Icon.png";
import { fetchUandetails, updateUanEmployment, uploadSalarySlip } from "../../Actions/uanActions";
import RightArrowIcon from "../../assets/img/arrow-right-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { CloudLightning } from "feather-icons-react/build/IconComponents";
import { toast } from "react-toastify";
// import cloneDeep from "lodash.clonedeep";
// import _ from "lodash";


const AddNewEmploymentDetailBlock = (props) => {
  const {setShowAddEmployment,handleCloseEmployment,formData} = props;
  const dispatch = useDispatch();
  const handleCancel=()=>{
    // props.setShowAddEmployment(false);
    // handleCloseEmployment();
    console.log(props);
    props.handleCloseEmployment();
    // props.setShowAddEmployment(false);
  }
  const [doj, setDoj]=useState('');
  const [doe, setDoe]=useState('');
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [allFiles, setAllFiles] = useState([]);
  const [isTillDate, setIsTillDate] = useState(false);
  const [isAddDisabled, setIsAddDisabled] = useState(false);
  const [errors,setErrors] = useState({});
  
  const handleAdd=()=>{
    // add api
    
    
    if(doj != "" && companyName != "" &&  allFiles.length>0 && (isTillDate||doe!='')){
      setIsAddDisabled(true);
      let record = {};
    console.log(allFiles)
    // record.uan_history_id = selectedId;
    record.candidate_id = props?.formData?.candidate_id;
    record.initial_case_id = props?.formData?.candidates?.initial_case_id;
    record.case_check_id = props?.formData?.checksDetails[0]?.case_check_id;
    record.company_name = companyName;
    record.date_of_joining = doj;
    record.date_of_exit = doe;
    record.uan_employment_proof = allFiles;
    record.father_name = '';
    record.is_till_date = isTillDate?1:0;
    // record.allFiles = _.cloneDeep(allFiles);
    
    console.log(record);
    dispatch(updateUanEmployment(record,callback));
    }
    else{
      // toast.dismiss();
      // toast.error("Please Fill all the Fields.", {
      //   position: "top-right",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      if(doe == '' && !isTillDate){
        setErrors((prev) => ({
          ...prev,
          doe: 'This field is required.'
        }))
      } 
      if(doj == ''){
        setErrors((prev) => ({
          ...prev,
          doj: 'This field is required.'
        }))
      }
      if(companyName == ''){
        setErrors((prev) => ({
          ...prev,
          companyName: 'This field is required.'
        }))
      }
      if(allFiles.length <= 0 ){
        setErrors((prev) => ({
          ...prev,
          upload: 'This field is required.'
        }))
      }

      setIsAddDisabled(false);
      return false;   
    }}
  
  const callback = (data, res) => {
    if(res?.code == 400){
      setIsAddDisabled(false);
    }else{
      dispatch(fetchUandetails(data?.candidate_id, data?.initial_case_id, data?.case_check_id));
      props.setShowAddEmployment(false);
      setCompanyName('');
      setDoe('');
      setDoj('');
      setAllFiles([]);
      setIsAddDisabled(false);
    }
  }

  const handleInputChange=(e)=>{
    console.log(e)
  }
  const saveDOJInput=(arg)=>{
    if (arg == "Invalid date") {
      setDoj('')    
      setErrors((prev) => ({
        ...prev,
        doj: 'This field is required.'
      }))
    }else{
      setDoj(arg);
      setErrors((prev) => ({
        ...prev,
        doj: ''
      }))
    }
  }
  const saveDOEInput=(arg)=>{
    if(arg == "Invalid Date"){
      setDoe('');
      setErrors((prev) => ({
        ...prev,
        doe: 'This field is required.'
      }))
    }else{
      setDoe(arg);
      setErrors((prev) => ({
        ...prev,
        doe: ''
      }))
    }
  }

  const handleTillDate=()=>{
    setIsTillDate(!isTillDate)
    setDoe('');
    setErrors((prev) => ({
      ...prev,
      doe: ''
    }))
  }

  // const handleChange = (file) => {
  //   let fil = file.name.lastIndexOf(".")+1;
  //   let fileType = file.name.substring(fil)

  //   if(fileType !== "png" && fileType !== "jpg" && fileType !== "pdf"){
  //     alert("Wrong file format");
  //     return false;
  //   }
   
  //     if (file.size > 3000000) {
  //       alert("File cannot be larger than 3mb");
  //       return false;
  //     }
  //   setFileName(file.name);
  //   setFileError(false);
  //   console.log(file)
  //   let record = {};
  //   record.mode = "uan_employment_proof";
  //   record.chkid = "2206206";
  //   record.docid ="1566";
  //   record.uan_employment_proof = [file];
  //   dispatch(uploadSalarySlip(record, file));

  //   // let formData = {};
  //   // formData.group = 21;
  //   // const currentUrl = window.location.href;
  //   // const [partA, partB] = currentUrl.split("/check-detail/");
  //   // const [reference, route] = partB.split("/");
  //   // formData.referenceNo = reference;
  //   // dispatch(getVisualDoc(formData));
  // };

  const handleChange = (file) => {
    let size=0;
    let extension_error=0;
    for(let i=0;i<file.length;i++){
      let arr = file[i]?.type.split('/')
      if(arr[arr.length-1] !== "png" && arr[arr.length-1] !== "jpg" && arr[arr.length-1] !== "pdf" && arr[arr.length-1] !== "jpeg"){
        extension_error+=1
      }
      size+=file[i]?.size
    }
  
    if(extension_error!=0){
      alert("Wrong file format");
      return false;
    }
   
      if (size> 5242880) {
        alert("File cannot be larger than 5mb");
        return false;
      }
      setFileName(file[0]?.name);
    setFileError(false);
    console.log(props?.formData)
    let record = {};
    record.mode = "uan_employment_proof";
    record.chkid = props?.formData?.checksDetails?.[0]?.case_check_id;
    // record.uan_history_id = selectedId;
    record.docid =props?.formData?.checksDetails?.[0]?.required_documents?.[0]?.id;
    // debugger
    const files = Object.keys(file).map(key => {
      const innerObject = file[key];
      return innerObject;
    });
    // const files = Object.values(file);
    
    record.uan_employment_proof = file;
    console.log(file)
    console.log(files);
    let totalFiles = [...allFiles];
    // totalFiles.push(allFiles);
    // totalFiles.push(files);
    // totalFiles.concat(files);
    files.map((data) => {
      totalFiles.push(data);
    })

    setAllFiles(totalFiles);
    setErrors((prev) => ({
      ...prev,
      upload: ''
    }))
    // setAllFiles(files);
    // dispatch(uploadSalarySlip(record, file));

  };
  const handleTrashClick = () => {
    // debugger;
    setFileName("");
    setAllFiles([]);
  };

  const renderDragDropChildren = () => (
    <>
      <input type="file" id="myFile" className="mt-2" name="filename" />

      {/* <div class="w-100 bg-gray p-5 mb-3 text-center file-upload">
        <ul class="mt-4">
          <li>
            <i data-feather="upload-cloud">
            
            </i>
          </li>
          <li class="mt-4">
           
            <p class="fnt-14 text-primary" style={{ cursor: "pointer" }}>
              Click to upload <span class="text-gray">or drag and drop</span>
            </p>
          </li>
          <li class="fnt-12 text-gray">XLS or CSV File (max. 5mb)</li>
        </ul>
      </div> */}

      <div className="row uploadBox justify-content-around border rounded w-100 bg-light rounded ml-1">
        <div className="col-2 align-self-center p-0">
          <img src={UploadIcon} alt="UploadIcon" width="32px" height="32px" />
        </div>
        <div className="col-8 align-self-center">
          <div className="row uploadCardText1">Upload “Document Name”</div>
          <div className="row uploadCardText2">
            upload PNG, JPG, PDF etc (max file size 5mb)
          </div>
        </div>
        <div className="col-1 align-self-center p-0">
          <img
            src={RightArrowIcon}
            alt="RightArrowIcon"
            height="10px"
            width="5px"
          />
        </div>
      </div>
    </>
  );

  const handleCompanyName = (e) => {
    setCompanyName(e.target.value);
    setErrors((prev) => ({
      ...prev,
      companyName: ''
    }))
  }
  console.log(isAddDisabled)
  console.log(errors);
  return (
    <>
      <div className="addNewEmploymentDetail px-1 py-3 my-3">
        <div className="addNewEmploymentDetail-title pl-3">
          Add New Employment Detail
        </div>

        <div className="pt-3">
          <form>
            <div className="form-group col-lg-6 col-md-12 col-sm-12 p-2">
              <label for="inputCity" className="addEmpCompanyName">
                Company Name <sup className="text-danger">{''}*</sup>
              </label>
              <input
                type="text"
                className="form-control addEmpCompanyInput"
                id="inputCity"
                placeholder="Enter Company Name"
                onChange={(e) => {handleCompanyName(e)}}
                value={companyName}
              />
              <p className="text-danger">{errors.companyName}</p>
            </div>
          </form>
        </div>

        <div className="p-2 row">
          <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 row">
          <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 w-100">
            <form>
              <div className="form-group col">
                <label for="inputDOJ" className="addEmplabelInput">
                  Date of Joining <sup className="text-danger">{''}*</sup>
                </label>
                <InputField
                        inputType="7" 
                        inputName='date_of_joining'                                      
                        saveDate={(index, argDate) => {
                          saveDOJInput(
                            argDate,
                           
                          );
                        }}
                        placeholder="Date of Joining"
                        // minimumDate={minimumDate}
                        maximumDate={doe}
                      />
                      <p className="text-danger">{errors.doj}</p>
              </div>
            </form>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 w-100">
            <form>
              <div className="form-group col">
              <label for="inputDOE" className="addEmplabelInput">
                  Date of Exit <sup className="text-danger">{''}*</sup>
                </label>
                {!isTillDate&&
                <InputField
                        inputType="7"     
                        inputName='date_of_exit'                                       
                        saveDate={(index, argDate) => {
                          saveDOEInput(
                            argDate,
                            
                            );
                          }}
                          placeholder="Date of Exit"
                          className="w-100"
                          minimumDate={doj}
                          // maximumDate={maximumDate}
                      />}
                <p className="text-danger">{errors.doe}</p>

                {/* Till Date-START */}
                <div className="form-group form-check mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="exampleCheck1"
                    onClick={handleTillDate}
                  />
                  <label className="form-check-label" for="exampleCheck1">
                    Till Date
                  </label>
                </div>
                {/* Till Date-END */}
              </div>
            </form>
          </div>
          </div>

          <div className="col-lg-4 col-md-12 col-sm-12">
            <label className="addEmplabelInput">Proof of Employment <sup className="text-danger">{''}*</sup></label>
            {/* <div className="addEmpUploadBox px-3">
              <img src={UploadIcon} alt="UploadIcon" />
              <div className="addEmpUploadBox-text">
                <div className="addEmpUploadBox-textMain">
                  Upload salary slip or Relieving letter
                </div>
                <div className="addEmpUploadBox-textSub">
                  upload PNG, JPG, PDF etc (max file size 3mb)
                </div>
              </div>
              
            </div> */}
            {  
                      (
                        <>
                        <FileUploader
                          hoverTitle={"Choose Files"}
                          classes={"file-upload w-100 border-0 mt-n2"}
                          handleChange={handleChange}
                          multiple={true}
                          name="file"
                          children={renderDragDropChildren()}
                          onSizeError={(file) => {
                            alert("file size larger than 5 mb");
                          }}
                          onClick={(e) => (e.target.value = null)}
                        />
                        <p className="text-danger" style={{marginTop:'-20px'}}>{errors.upload}</p>
                        {/* {fileError ? (
                          <p className="text-danger">
                            This is a required field.
                          </p>
                        ) : (
                          ""
                        )} */}
                        </>
                      )} 
                      {fileName != '' && 
                      (
                        <>
                          <div
                            style={{
                              maxHeight: "69px",
                              cursor: "pointer",
                              borderRadius: "4px",
                              border: "1px solid var(--gray-300, #D0D5DD)",
                              background: "var(--White, #FFF)",
                            }}
                            className="col-12 d-flex align-items-center justify-content-center bg-white uploadedDoc my-2 w-100 ml-1"
                          >
                            {/* <img
                              //  src={UploadedDoc}
                              alt="UploadedDoc"
                              style={{
                                maxWidth: "65px",
                                width: "100%",
                              }}
                            /> */}
                            <div className="d-flex align-items-center justify-content-between w-100 mx-3">
                              <p
                                className="text-truncate pt-3"
                                style={{
                                  maxWidth: 200,
                                }}
                              >
                                {allFiles.length} files uploaded
                              </p>
                              <img
                                src={Bin}
                                onClick={() => handleTrashClick()}
                                alt="Delete"
                                style={{ maxWidth: "15px", width: "100%" }}
                              />
                            </div>
                          </div>
                        </>
                      )}
          </div>
          <div className="col col3 addEmp-buttonsBox p-2 pt-4">
            <div
              className="btn addEmp-cancelbtn"
              onClick={handleCancel}
            >
              Cancel
            </div>
            <button
              className="btn addEmp-addbtn"
              onClick={handleAdd}
              disabled={isAddDisabled}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewEmploymentDetailBlock;
